import { MyDetailsCard, ChangePasswordCard, NotificationPrefs } from "./PatientExtras";
import { TimezoneCard } from "./TimezoneCard";

// Personal account area reused across staff dashboards (clinician / admin / super admin):
// My Details + Change Password + Notification Preferences + Time Zone.
export function AccountArea() {
  return (
    <div className="max-w-2xl grid gap-6" data-testid="account-area">
      <MyDetailsCard />
      <ChangePasswordCard />
      <NotificationPrefs />
      <TimezoneCard />
    </div>
  );
}
